import React from "react";

export default function InsuranceIcon() {
  return (
    <svg
      width="19"
      height="19"
      viewBox="0 0 19 19"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M16.5656 2.82029C16.3875 2.82029 16.1797 2.7906 16.0016 2.76091C15.5563 2.70154 15.1109 2.67185 14.725 2.61248C13.1812 2.3156 11.7266 1.69216 10.3609 0.742163C10.1234 0.564038 9.82656 0.474976 9.55937 0.474976H9.47031C9.20312 0.474976 8.90625 0.564038 8.66875 0.742163C7.27344 1.72185 5.84844 2.34529 4.30469 2.61248C3.88906 2.67185 3.47344 2.73123 3.02812 2.76091C2.85 2.76091 2.64219 2.7906 2.46406 2.82029C1.60313 2.90935 1.1875 3.59216 1.1875 4.2156C1.1875 7.18435 1.72187 9.64841 2.73125 11.8453C4.00781 14.5765 6.05625 16.7734 8.84687 18.3469C9.025 18.4359 9.23281 18.4953 9.47031 18.525H9.55937C9.79688 18.525 10.0047 18.4656 10.1828 18.3469C12.9734 16.7437 15.0219 14.5765 16.2984 11.8453C17.3078 9.64841 17.8125 7.15466 17.8719 4.2156C17.8422 3.59216 17.4266 2.90935 16.5656 2.82029ZM14.7844 11.0437C13.6859 13.4187 11.875 15.3484 9.44063 16.7734V9.47029H3.47344C2.96875 7.95623 2.73125 6.38279 2.70156 4.54216H2.85C2.93906 4.54216 2.99844 4.51248 3.0875 4.51248L3.325 4.48279C3.71094 4.4531 4.12656 4.39373 4.54219 4.33435C6.29375 4.00779 7.89687 3.32498 9.47031 2.22654V9.47029H15.4672C15.2891 10.0047 15.0516 10.5094 14.7844 11.0437Z"
        fill="white"
      />
    </svg>
  );
}
